"use client";

import { useTranslations } from "next-intl";


type TipCalloutProps = {
  readonly content: string;
};

export const TipCallout = ({ content }: TipCalloutProps) => {
  const t = useTranslations("common");
  return (
    <div className="not-prose my-6 rounded-xl bg-brand-grey1 p-5 md:p-6">
      <header className="mb-3 flex items-center ">
        <p className="m-0 font-medium text-brand-green1-300 text-lg"><span>💡</span> <span className="ml-2 ">{t("tip")}</span></p>
      </header>
      <p className="m-0 whitespace-pre-line text-base leading-7 text-brand-black">
        {content}
      </p>
    </div>
  );
};
